// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"74":"205c6e08","312":"ad35c4cf","410":"cbc7e37a","962":"727eff18","981":"80be1de6"}[chunkId] + ".css";
};